import { RouteLocationRaw } from "vue-router"

import { FilterSprint } from "@/models/Filter/FilterSprint"
import { Actions, Getters, store } from "@/store"

export default async (
  to,
  from,
  next: (arg?: RouteLocationRaw) => void
): Promise<void | boolean> => {
  await store.dispatch(Actions.RESET_SPRINT)
  let currentSprintId = store.getters[Getters.GET_CURRENT_SPRINT_ID]
  const team = store.getters[Getters.GET_TEAM]
  if (!team.includedInSubscription) {
    return next({
      name: "SubscriptionError",
      params: {
        accountId: to.params.accountId
      },
      query: {
        f: "sprint"
      }
    })
  }
  if (currentSprintId) {
    const currentSprint = await store.dispatch(Actions.GET_SPRINT, {
      sprintId: currentSprintId
    })
    // Check if the current sprint is neither started nor not started
    if (!currentSprint.isStarted && !currentSprint.isNotStarted) {
      // Redirect to the SprintReview if the current sprint is completed or halted
      return next({
        name: "SprintReview",
        params: to.params
      })
    }
  }

  const filterSprints = FilterSprint.createDefault()
  const teamId = store.getters[Getters.GET_CURRENT_TEAM_ID]
  if (!currentSprintId && to.params.sprintId) {
    currentSprintId = await store.dispatch(Actions.RESOLVE_SESSION_SPRINT_ID, {
      sequenceNumber: to.params.sprintId,
      teamId
    })
  }
  filterSprints.teamIds = [teamId]
  filterSprints.includedStatuses = ["STARTED"]
  filterSprints.projectId = store.getters[Getters.GET_CURRENT_PROJECT_ID]
  const activeSprintsResponse = await store.dispatch(Actions.SEARCH_SPRINT, {
    filter: filterSprints,
    onlyGet: true
  })
  const activeSprint = activeSprintsResponse.content[0]
  const isActiveSprint = to.params.sprintId === "active" || currentSprintId === activeSprint?.id
  if (!activeSprint && isActiveSprint) {
    return next({
      name: "Error",
      query: {
        code: 404
      }
    })
  }
  if (isActiveSprint) {
    store.dispatch(Actions.SET_SESSION_SPRINT_ID, activeSprint.id)
  }
  if (to.params.sprintId !== "active" && isActiveSprint) {
    return next({
      name: to.name,
      params: { ...to.params, sprintId: "active" },
      query: to.query
    })
  }
  return next()
}
